// Events.js
import React from "react";
import { EVENTS } from "../utils/config";

export default function Events() {
  return (
    <section
      id="events"
      style={{ background: "var(--mint-p)", padding: "96px 36px" }}
    >
      <div style={{ maxWidth: "960px", margin: "0 auto" }}>
        <div className="reveal" style={{ marginBottom: "44px" }}>
          <div className="section-tag">The Celebrations</div>
          <h2 className="section-title">
            Four Days of <em>Joy</em>
          </h2>
          <p
            style={{
              fontSize: "13.5px",
              lineHeight: 1.9,
              color: "var(--muted)",
              marginTop: "12px",
              maxWidth: "520px",
            }}
          >
            Our wedding is a full cultural journey - each day tells a different
            chapter of who we are.
          </p>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "18px",
          }}
          className="grid-2-mobile"
        >
          {EVENTS.map((ev, i) => (
            <div
              key={i}
              className="event-card reveal"
              style={{
                background: "#fff",
                border: ev.highlight
                  ? `1.5px solid var(--sage)`
                  : `0.5px solid var(--sage-p)`,
                borderRadius: "10px",
                overflow: "hidden",
                transitionDelay: `${i * 0.1}s`,
              }}
            >
              <div style={{ height: "3px", background: ev.bar }} />
              <div style={{ padding: "24px 24px 20px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "12px",
                  }}
                >
                  <div style={{ textAlign: "center", minWidth: "50px" }}>
                    <div
                      style={{
                        fontSize: "8px",
                        letterSpacing: ".18em",
                        textTransform: "uppercase",
                        color: "var(--gold)",
                      }}
                    >
                      {ev.month}
                    </div>
                    <div
                      style={{
                        fontFamily: "var(--font-serif)",
                        fontSize: "48px",
                        fontWeight: 300,
                        lineHeight: 1,
                        color: "var(--deep)",
                      }}
                    >
                      {ev.day}
                    </div>
                  </div>
                  <span
                    style={{
                      fontSize: "8px",
                      letterSpacing: ".12em",
                      textTransform: "uppercase",
                      padding: "3px 11px",
                      borderRadius: "18px",
                      background: ev.badgeBg,
                      color: ev.badgeColor,
                      alignSelf: "flex-start",
                    }}
                  >
                    {ev.badge}
                  </span>
                </div>
                <div style={{ fontSize: "19px", marginBottom: "7px" }}>
                  {ev.icon}
                </div>
                <div
                  style={{
                    fontFamily: "var(--font-serif)",
                    fontSize: "21px",
                    marginBottom: "7px",
                    color: "var(--deep)",
                  }}
                >
                  {ev.name}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "var(--muted)",
                    lineHeight: 1.85,
                    whiteSpace: "pre-line",
                  }}
                >
                  {ev.detail}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
